<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
export default {
  mixins: [fandomBasicMixin],
  methods: {
    getTarget: Fandom.getTarget,
    getUrl(url) {
      if (url.includes("?")) {
        return `${url}&icmp=footer`;
      } else {
        return `${url}?icmp=footer`;
      }
    },
    toggleDropdowns(event, index) {
      $("#all-dropdowns-toggler").toggleClass('reversed');
      $(event.target).toggleClass('collapsed');
      const vp = globalState.viewport;
      if (vp.xs || vp.sm) {
        $(`#items-${index}`).collapse('toggle');
      } else {
        this.content.navbar.forEach((_, i) => {
          $(`#items-${i}`).collapse('toggle');
        })
      }
    },
  }
};
</script>

<template>
  <div footer-component>
    <!-- <footer-newsletter :content="content.newsletter" v-if="content.newsletter"></footer-newsletter> -->
    <div class="w-100 bg-gray-900">
      <div class="container py-0 py-md-5 px-4">
        <div class="row py-3">
          <div class="col-12 col-md my-2">
            <a
              v-for="(icon, index) in content.social_icons"
              :key="`icon-${index}`"
              :href="getUrl(icon.url.url)"
              :target="getTarget(icon.url)"
              class="text-white mr-4"
            >
              <i class="fab icon" :class="icon.icon"></i>
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-12 px-0 px-md-3">
            <div class="w-100 divider"></div>
          </div>
        </div>
        <div class="row pt-md-4">
          <div
            v-for="(section, sectionIndex) in content.navbar"
            :key="`section-${sectionIndex}`"
            class="col-12 col-md py-4 py-md-0 border-bottom collapsable-section"
          >
            <a
              href="javascript:void(0)"
              @click="toggleDropdowns($event, sectionIndex)"
              class="collapsed d-flex justify-content-between font-weight-normal text-white mb-0 mb-md-3 collapsable-toggle font-lg"
            >
              {{section.title}}
              <i class="far fa-chevron-down d-flex align-items-center text-white d-md-none"></i>
            </a>
            <div :id="`items-${sectionIndex}`" class="collapse">
              <div v-for="(item, itemIndex) in section.items" :key="`item-${sectionIndex}-${itemIndex}`" class="pt-2">
                <a :href="getUrl(item.url.url)" :target="getTarget(item.url)" class="text-white navbar-item">{{item.url.title}}</a>
              </div>
            </div>
          </div>
          <div class="d-none d-md-flex col-md-1 justify-content-end">
            <i class="far fa-chevron-down text-white cursor-pointer" id="all-dropdowns-toggler" @click="toggleDropdowns($event)"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 bg-dark">
      <div class="container">
        <div class="row py-3">
          <div class="col-12 col-md-6 d-flex flex-wrap">
            <div v-for="(item, index) in content.navbar_bottom" :key="`bottom-item-${index}`">
              <a :href="getUrl(item.url.url)" :target="getTarget(item.url)" class="text-gray-400 small">
                {{item.url.title}}
              </a>
              <span class="text-gray-400 mx-2" v-if="index != (content.navbar_bottom.length - 1)">|</span>
            </div>
          </div>
          <div class="col-12 col-md-6 d-flex text-gray-400 justify-content-sm-end align-items-center small mt-4 mt-md-0">
            {{content.disclaimer}}
          </div>
          <div class="col-12 small pt-4 mt-md-0">
            <p class="small text-gray-400">
              This site is protected by reCAPTCHA and the Google
              <a data-v-7336ad21="" href="https://policies.google.com/privacy">Privacy Policy</a> and
              <a data-v-7336ad21="" href="https://policies.google.com/terms">Terms of Service</a> apply.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[footer-component] {

  .font-lg {
    @include font-size(1.25rem);
  }

  .bg-quite-dark {
    background-color: rgba(0,0,0,.3);
  }

  .fa-chevron-down {
    transition: all .5s;
    width: 1rem;
    height: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .reversed {
    transform: rotate(180deg);
  }

  .collapsable-toggle:not(.collapsed) > .fa-chevron-down {
    transform: rotate(180deg);
  }

  .icon {
    @include font-size(2.125rem);
  }

  .divider {
    height: 1px;
    background-color: #444444;
  }

  .border-bottom {
    border-bottom: 1px solid #444444 !important;
  }

  .navbar-item {
    display: block;
    @include font-size(1.25rem);
  }

  @include media-breakpoint-up(md) {
    .collapsable-section.border-bottom {
      border-bottom: 0 !important;
    }
  }
}
</style>
